import React, { Component } from 'react';
import { Modal, Form, Button, Input } from 'antd';
const { TextArea } = Input;

export default function AddLink({ open, onCancel, title, updateGuideline, loading }) {
    const [form] = Form.useForm();

    const HandleFinish = data => {
        const { link } = data;
        updateGuideline(link);
    };
    return (
        <>
            <Modal title={title} open={open} onCancel={onCancel} footer={null} width="80%">
                <div style={{ width: '100%', height: '70vh' }}>
                    <Form form={form} onFinish={HandleFinish}>
                        <Form.Item label="Link" name="link" colon={true}>
                            <TextArea />
                        </Form.Item>
                        <Form.Item>
                            <Button block type="primary" htmlType="submit" hidden={true} disabled={loading} loading={loading}>
                                Add Link
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    );
}
